function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.675 15.45C9.3 15.45 9.075 15.375 8.925 15.3C8.775 15.225 8.775 15.15 8.775 15V1.05H8.85C9.75 1.05 10.425 1.125 10.95 1.2C11.475 1.275 11.85 1.35 12.075 1.5C12.375 1.65 12.525 1.8 12.675 1.95C12.825 2.175 12.9 2.4 12.975 2.7L13.575 5.25H14.85V0H0.45L0 5.175H1.35L2.1 2.325C2.175 2.025 2.325 1.8 2.4 1.65C2.55 1.5 2.775 1.35 3.075 1.275C3.375 1.2 3.75 1.125 4.275 1.125C4.8 1.125 5.475 1.05 6.3 1.05H6.375V15C6.375 15.15 6.3 15.225 6.15 15.3C6 15.375 5.775 15.45 5.4 15.45L3.75 15.6L3.675 16.5H11.325L11.25 15.6L9.675 15.45ZM15.75 9V6.75H14.25V9H12V10.5H14.25V12.75H15.75V10.5H18V9H15.75Z",
  fill: "#979797"
});

var SvgMoreText = function SvgMoreText(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoreText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MoreText.311bfe4c.svg";
export { ForwardRef as ReactComponent };